import { AxiosError } from 'axios';
import { useCallback, useState } from 'react';

import { ThirdPartyAccessInterface } from '../../../models/dashboard/settings/third-party-access.model';
import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

// Fall back to the expiry date when the API does not send a status
const resolveStatus = (item: any): ThirdPartyAccessInterface['status'] => {
  if (item?.status) {
    return String(item.status).toLowerCase() === 'active' ? 'Active' : 'Expired';
  }
  return new Date(item?.expiresAt) > new Date() ? 'Active' : 'Expired';
};

const useGetThirdPartyAccess = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(true);
  const [thirdPartyAccessList, setThirdPartyAccessList] = useState<
    ThirdPartyAccessInterface[]
  >([]);

  const onGetThirdPartyAccessError = useCallback(
    (err: AxiosError<ErrorHttpResponse>) => {
      console.error(err?.response?.data?.message ?? 'Something went wrong');
      setThirdPartyAccessList([]);
    },
    [],
  );

  const onGetThirdPartyAccessSuccess = useCallback(
    ({ data }: SuccessHttpResponse<any>) => {
      const records = Array.isArray(data) ? data : (data?.records ?? []);
      setThirdPartyAccessList(
        records.map((item: any) => ({ ...item, status: resolveStatus(item) })),
      );
    },
    [],
  );

  const getThirdPartyAccess = useCallback(() => {
    const url: HttpConfig = {
      url: `api/v1/partner-api-keys`,
      method: 'get',
    };

    request(url, onGetThirdPartyAccessSuccess, setLoading, onGetThirdPartyAccessError);
  }, [request, onGetThirdPartyAccessSuccess, onGetThirdPartyAccessError]);

  return { getThirdPartyAccess, thirdPartyAccessList, loading };
};

export default useGetThirdPartyAccess;
